import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PinOutlinedIcon from '@mui/icons-material/PinOutlined';
import TextFieldsOutlinedIcon from '@mui/icons-material/TextFieldsOutlined';
import {
  FieldTypeEnum,
  ClientDTO,
  ClosureFiltersDTO,
  getFullTextSearchString,
  InvoiceStatus,
  IOurEntity,
} from 'wisestep-api';

import { IOption } from '../../../components/SettingsIndex';
import {
  NORTHHILLPARTNERS_WORKSPACE_ID,
  CRUCIBLE_WORKSPACE_ID,
  VANCY_WORKSPACE_ID,
} from '../../../utils/Constants';
import { isBlank } from '../../../utils/StringUtils';

export interface ClosureFiltersForm {
  invoiceStatusList?: string[];
  candidateSearch: string | null;
  ourEntities: IOurEntity[];
  clients: ClientDTO[];
  fromJoiningDate?: Date;
  toJoiningDate?: Date;
}

export const mapClosureFiltersToDTO = ({
  invoiceStatusList,
  clients,
  candidateSearch,
  ourEntities,
  fromJoiningDate,
  toJoiningDate,
}: ClosureFiltersForm): ClosureFiltersDTO => ({
  invoiceStatusList: invoiceStatusList?.map((status) => InvoiceStatus[status]),
  clientIds: clients?.map(({ id }) => id),
  candidateSearch: isBlank(candidateSearch)
    ? undefined
    : getFullTextSearchString(candidateSearch as string),
  ourEntityIds: ourEntities.map((ourEntity) => ourEntity.id as string),
  fromJoiningDate,
  toJoiningDate,
});

export interface IClosureToInvoice {
  ouEntity: string;
  clientEntity: string;
  candidateName: string;
  candidateCompensationAmount: string;
  candidateFeeArrangement: string;
  candidateCommissionValue: string;
  currencyId: string;
  currencySymbol: string;
}

export const placementSettingsIndexOptions: IOption[] = [
  { label: 'Placement Status', url: '/placements/settings/placement_status' },
  { label: 'Placement Origin', url: '/placements/settings/placement_origin' },
  { label: 'Placement Stage', url: '/placements/settings/placement_stage' },
  { label: 'Customize Placement Fields', url: '/app-settings/customize-placement-fields' },
  { label: 'Contract Revenue Calculator', url: '/placements/settings/contract_revenue_calculator' },
];

export const hardcodedClosureFields = [
  {
    label: 'Client Name',
    type: FieldTypeEnum.TextBox,
  },
  {
    label: 'Organisation Entity',
    type: FieldTypeEnum.TextBox,
  },
  {
    label: 'Candidate Name',
    type: FieldTypeEnum.TextBox,
  },
  {
    label: 'Candidate Location ',
    type: FieldTypeEnum.TextBox,
  },
  {
    label: 'Candidate Email',
    type: FieldTypeEnum.TextBox,
  },
  {
    label: 'Candidate Contact',
    type: FieldTypeEnum.TextBox,
  },
  {
    label: 'Offer Date',
    type: FieldTypeEnum.Date,
  },
  {
    label: 'Joining Date',
    type: FieldTypeEnum.Date,
  },
  {
    label: 'Business Unit',
    type: FieldTypeEnum.TextBox,
  },
  {
    label: 'Placement Status Name',
    type: FieldTypeEnum.Dropdown,
  },
  {
    label: 'Placement Origin',
    type: FieldTypeEnum.TextBox,
  },
].map((field) => ({ ...field, hardcoded: true }));

export const isEligibleForWisestepCandidates = (workspaceId: string): boolean => {
  const workspacesEligibleForWisestepCandidate: string[] = [
    CRUCIBLE_WORKSPACE_ID,
    VANCY_WORKSPACE_ID,
    NORTHHILLPARTNERS_WORKSPACE_ID,
  ];

  return workspacesEligibleForWisestepCandidate.indexOf(workspaceId) >= 0;
};

export const FieldIconMap = {
  TextBox: TextFieldsOutlinedIcon,
  Number: PinOutlinedIcon,
  Date: CalendarMonthOutlinedIcon,
  Location: LocationOnOutlinedIcon,
  DateAndTime: AccessTimeOutlinedIcon,
  URL: LinkOutlinedIcon,
  Tags: LocalOfferOutlinedIcon,
  Dropdown: DnsOutlinedIcon,
  Users: GroupOutlinedIcon,
  Checkbox: CheckBoxOutlinedIcon,
};

export const FieldNameMap = {
  TextBox: 'TextBox',
  Number: 'Number',
  Date: 'Date',
  Location: 'Location',
  DateAndTime: 'Date And Time',
  URL: 'URL',
  Tags: 'Tags',
  Dropdown: 'Dropdown',
  Users: 'Users',
  Checkbox: 'Checkbox',
};

export const fieldTypes = [
  'TextBox',
  'Number',
  'Date',
  'Location',
  'DateAndTime',
  'URL',
  'Tags',
  'Dropdown',
  'Users',
  'Checkbox',
] as const;
